<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'Remedies',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>